<template>
	<div class="common-container">
		<div class="drag__wrapper" ref="dragRef" :style="{ left: pos.x + 'vw', top: pos.y + 'vw' }" @mousemove="onTouchMove" @touchmove.stop="onTouchMove">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	props: {
		position: {
			type: Object,
			default: () => {
				const x = 666 / 8.28;
				const y = 1118 / 8.28;
				return { x, y };
			}
		}
	},
	data() {
		return {
			flags: false,
			pos: { x: 0, y: 0 },
			wrapperHalfWidth: 0,
			wrapperHalfHeight: 0,
			limitLeft: 0,
			limitRight: 0,
			limitTop: 0,
			limitBottom: 0
		};
	},
	created() {},
	mounted() {
		this.init();
	},
	computed: {},
	filters: {},
	methods: {
		init() {
			// 容器
			const rect = this.$refs.dragRef.getBoundingClientRect();
			this.wrapperHalfWidth = rect.width / 2;
			this.wrapperHalfHeight = rect.height / 2;
			// 屏幕
			this.clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
			this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
			// 边界 左右：20 上：110 下：160
			this.limitLeft = this.countDesign(20);
			this.limitRight = this.countDesign(828 - 20) - this.conutPoint(rect.width);
			this.limitTop = this.countDesign(110);
			this.limitBottom = this.conutPoint(this.clientHeight) - this.countDesign(160) - this.conutPoint(rect.height);
			// 初始化位置
			this.pos = {
				x: this.limitRight,
				y: this.limitBottom - this.countDesign(20)
			};
		},
		countDesign(val) {
			return val / 8.28;
		},
		conutPoint(val) {
			const rate = this.clientWidth / 100;
			return val / rate;
		},
		onTouchMove(e) {
			e.preventDefault();
			// 获取触点
			let touch = e;
			if (e.touches) touch = e.touches[0];
			// 定位位置
			this.pos.x = this.conutPoint(touch.clientX - this.wrapperHalfWidth);
			this.pos.y = this.conutPoint(touch.clientY - this.wrapperHalfHeight);
			// 处理边界
			if (this.pos.x <= this.limitLeft) {
				this.pos.x = this.limitLeft;
			} else if (this.pos.x > this.limitRight) {
				this.pos.x = this.limitRight;
			}
			if (this.pos.y <= this.limitTop) {
				this.pos.y = this.limitTop;
			} else if (this.pos.y > this.limitBottom) {
				this.pos.y = this.limitBottom;
			}
		}
	}
};
</script>

<style lang="less" scoped>
.common-container {
	.drag__wrapper {
		position: fixed;
		z-index: 333;
	}
}
</style>
